import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { validateFloatInput } from '@gk/gk-modules';
import { TranslateModule } from '@ngx-translate/core';
import {
  MCGRNewRequestSettlementScopeControlName,
  MCGRSettlementScopeFormGroup,
} from './costs-section-form.model';
@Component({
  selector: 'app-mcgr-costs-section',
  templateUrl: './costs-section.component.html',
  imports: [CommonModule, TranslateModule, ReactiveFormsModule],
})
export class MCGRCostsSectionComponent {
  controlName = MCGRNewRequestSettlementScopeControlName;
  @Input() formGroup: FormGroup<MCGRSettlementScopeFormGroup>;
  @Input() submitted: boolean;
  @Input() sectionHeader: string;
  @Input() idPrefix = '';

  validateFloatInput(event: KeyboardEvent): void {
    if (!validateFloatInput(event.key)) {
      event.preventDefault();
    }
  }
}
